/**
 * Organization domain types shared by both apps.
 *
 * Original locations: (identical values, verified):
 *  - web: apps/web/src/store/queries/organizations/types.ts (InviteError)
 *  - api: apps/api/src/organization/interfaces/organization.types.ts (InviteError)
 */
/** Reason a member invitation was rejected. Values are user-facing messages. */
export var InviteError;
(function (InviteError) {
    InviteError["Invalid"] = "Invalid email";
    InviteError["ExistingInvitation"] = "User has already been invited.";
    InviteError["BelongsToOrganization"] = "User already belongs to another organization";
    InviteError["NonSSO"] = "Email domain is not part of your SSO connection";
    InviteError["ScimManaged"] = "This user is managed by your identity provider.";
})(InviteError || (InviteError = {}));
//# sourceMappingURL=organization.js.map